// 🔧 GLOBAL MONKEY-PATCH: Catch ALL createClient calls before Angular bootstraps
console.warn('🚨 GLOBAL: Setting up createClient monkey-patch...');

// Set up a global error handler to catch any createClient calls
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    if (event.error && event.error.message && 
        event.error.message.includes('createClient')) {
      console.warn('🚨 GLOBAL: Detected createClient error', {
        message: event.error.message,
        stack: event.error.stack,
        timestamp: new Date().toISOString()
      });
    }
  });
}

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
